module.exports = __webpack_public_path__ + "static/media/laura.e9528947.png";